import { localizedStrings } from '@core/strings'

const AREA_CONVERSION_THRESHOLD = 100_000 // When to switch to km² display
const AREA_CONVERSION_FACTOR = 1_000_000 // How to convert m² to km² (1 km² = 1,000,000 m²)

type AreaSize = {
  unit: 'KM' | 'M'
  value: number
  unitName: string
  displayValue: string
}

export const formatAreaSize = (squareMeters: number): AreaSize => {
  if (squareMeters >= AREA_CONVERSION_THRESHOLD) {
    const squareKilometers = squareMeters / AREA_CONVERSION_FACTOR
    return {
      unit: 'KM',
      value: squareKilometers,
      unitName: localizedStrings.km2,
      displayValue: squareKilometers.toFixed(2).toLocaleString(),
    }
  }

  return {
    unit: 'M',
    value: squareMeters,
    unitName: localizedStrings.m2,
    displayValue: Math.round(squareMeters).toLocaleString(),
  }
}
